import React from "react";

export const Conclusion = ({block}) => {
  return <div className="blog-content-conclusion-container blog-border-bottom">
    <div className="blog-content-conclusion">
      <h3 className="blog-content-conclusion-title" id="conclusion">Conclusion</h3>
      <div className="blog-content-conclusion-body" dangerouslySetInnerHTML={{__html: block.data.text}}/>
    </div>
  </div>
}